const host = process.env.VUE_APP_BACKEND_HOST || '';

export default {
  apiEndpoint: `${host}/api`,
  baseEndpoint: `${host}`,
}
